import {Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';
import { Fill, Icon, Stroke, Style, Text, Circle as CircleStyle, RegularShape } from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';


import { NSFunctions } from "./utils/functions";
import { Map as Module_Map } from './map';
import { NSGeoJson } from "./utils/geojson";

import {unByKey} from 'ol/Observable';
import { NSObjectMultipleSelect } from './obj_multiple_select';

export let NSObjDetailsGeo = {};

/*
Test Example at end of file...


*/



NSObjDetailsGeo.init = function()
{
    NSObjDetailsGeoPrivate.init();
	
//	this.init = 	                    function () { return NSObjDetailsGeoPrivate.init.apply( NSObjDetailsGeoPrivate, arguments ); };

    //this.objs = NSObjDetailsGeoPrivate.objs;
    this.objs = {};
    this.objs.GeoHighlight = NSObjDetailsGeoPrivate.objs.GeoHighlight;
    this.objs.AddFromGeojsonGeometryIn = NSObjDetailsGeoPrivate.objs.AddFromGeojsonGeometryIn;
    this.objs.GeoHighlightStyleSimpleIn = NSObjDetailsGeoPrivate.objs.GeoHighlightStyleSimpleIn;

	
	
	window.NSObjDetailsGeo_ = NSObjDetailsGeo;
	window.NSObjDetailsGeoPrivate_ = NSObjDetailsGeoPrivate;
	
}



let NSObjDetailsGeoPrivate = 
{
    init: function ()
    {

    },

    objs: {

        GeoHighlight: function()
        {

            /*
                public methods:
                
                f_add_from_geojson_geometry
                f_remove
                f_remove_all
                f_destroy
            */


            //private section:
            let private_objs = 
            {

                map: null,
                vector_source: null,
                vector_layer: null,
                map_click_listner_key: null,
                style: null,

                a_geo: [] // [GeoVectorWrapper]
            };

            private_objs.map = Module_Map.f_get_map();
    
            /*
            private_objs.style =  new Style({
                fill: new Fill({
                color: 'rgba(255, 255, 255, 0.2)',
                }),
                stroke: new Stroke({
                color: '#ffcc33',
                width: 2,
                }),
                image: new CircleStyle({
                radius: 7,
                fill: new Fill({
                    color: '#ffcc33',
                }),
                }),
            });
            */
            
    
            private_objs.vector_source = new VectorSource();
            private_objs.vector_layer = new VectorLayer({
                source: private_objs.vector_source,
                style: 
                        //private_objs.style
                        function (feature) {
                            //window.o_vl_= o_vl;
                            //window.feature_ = feature;
                            //return style_simple_selected;
                            
                            //if no style is returned feature is not visible
                            return f_get_style_selected(
                                                        feature
                                                        //, overlay_vector.tree_node
                                                        );
                            
                            
                        }
                ,
                zIndex : 1000
            });

            private_objs.map.addLayer(private_objs.vector_layer);
            /*
            map events: click, pointermove, ...
            */
            private_objs.map_click_listner_key = private_objs.map.on(['click'], function (event) {
                if(NSObjectMultipleSelect.f_is_active()) return;
                if (
                    (event.type !== 'click')
                ) {
                    return;
                }
                private_objs.vector_layer.getFeatures(event.pixel).then(function (features) {
                    if (features.length > 0) 
                    {
                        const feature = features[0];
                        let f_onclick = feature.custom_extra_info.f_onclick;
                        if(f_onclick)
                        {
                            let o_geo_json_feature =  new GeoJSON().writeFeatureObject(feature, {rightHanded: true});
                            f_onclick(event, o_geo_json_feature);
                        }

                    }
                });
            });
            
            let f_get_pos = function(s_guid)
            {
                //var private_objs = this.private_objs;
                var a_geo = private_objs.a_geo;
                
                for(var i=0; i<a_geo.length; i++)
                {
                    var o_i = a_geo[i];
                    if (o_i.guid == s_guid)
                    {
                        return i;
                    }
                }
                
            };

            let f_get_style_selected = function (feature/*, tree_node*/) {

                /*
                //console.log(feature);
                let icon_displacement;
                if(feature.custom_extra_info && feature.custom_extra_info.b_is_icon)
                {
                    //let i_icon_height = feature.custom_extra_info.icon_size[1];
                    let i_icon_height = feature.custom_extra_info.a_icon_size_xy[1];
                    //icon_displacement = feature.custom_extra_info.icon_displacement;
                    icon_displacement = [0, (i_icon_height/2)];
                }
                
                
            
                let image = new CircleStyle({
                    radius: 35, //40, //30
                    //fill: null, -> will affect select event!!!!!!
                    fill: new Fill({ color: 'rgba(255,255,255,0.0)' }),
                    stroke: new Stroke({color: '#FF0000', width: 10}),
                    displacement: icon_displacement
                
                });
                
                let style_selected = new Style({
                    image: image,
                    fill: new Fill({
                        color: NSFunctions.f_hex_to_rgb('#FF0000', 0.5) //'#ADD8E6''
                    }),
                    stroke: new Stroke({
                        color: '#FF0000', //'#880000',
                        width: 4
                    })
                });
            
                return style_selected;
                */

                let style_selected = f_generate_openlayers_style(feature.custom_extra_info.style_simple)
                return style_selected;
            
            };

            /**
            * 
            * @param {GeoHighlightStyleSimpleIn} o_in 
            * 
            * @returns Openlayers Style object
            */
            let f_generate_openlayers_style = function(o_in)
            {
                let b_add_displacement_to_highlight_an_icon = o_in.b_add_displacement_to_highlight_an_icon;
                let a_icon_size_xy = o_in.a_icon_size_xy;
                
                let default_color = '#FF0000';
                let default_opacity = 1.0;
                let default_width = 3;
                let default_fill_color = '#FF0000';
                let default_fill_opacity = 0.0;

                let color =                     (o_in.color!=null)? o_in.color : default_color;
                let opacity =                   (o_in.opacity!=null)? o_in.opacity : default_opacity;
                let width =                     (o_in.width!=null)? o_in.width : default_width;
                let fill_color =                (o_in.fill_color!=null)? o_in.fill_color : default_fill_color;
                let fill_opacity =              (o_in.fill_opacity!=null)? o_in.fill_opacity : default_fill_opacity;

                let openlayers_style = null;

                //console.log(feature);
                let icon_displacement;
                if(b_add_displacement_to_highlight_an_icon)
                {
                    //let i_icon_height = feature.custom_extra_info.icon_size[1];
                    let i_icon_height = a_icon_size_xy[1];
                    //icon_displacement = feature.custom_extra_info.icon_displacement;
                    icon_displacement = [0, (i_icon_height/2)];
                }
                

                let image = new CircleStyle({
                    radius: 22,//35, //40, //30
                    //fill: null, -> will affect select event!!!!!!
                    fill: new Fill({ color: 'rgba(255, 255, 255, 0.0)' }),
                    stroke: new Stroke({color: color, width: width}),
                    displacement: icon_displacement
                
                });
                
                let style_selected = new Style({
                    image: image,
                    fill: new Fill({
                        color: NSFunctions.f_hex_to_rgb(fill_color, fill_opacity) //'#ADD8E6''
                    }),
                    stroke: new Stroke({
                        color: color, //'#880000',
                        width: width
                    })
                });


                openlayers_style = style_selected;

                return openlayers_style;
            };
            




            //public section:
           
            
            /**
             * 
             * @param {AddFromGeojsonGeometryIn} o_in
                o_in : {
                    s_guid, 
                    urn, 
                    o_geojson_feature_geometry, 
                    style_simple,
                    f_onclick
                }
             */
            this.f_add_from_geojson_geometry = function (o_in)
            {
                //console.log("f_add_from_geojson_geometry");
                //var private_objs = this.private_objs;
                let a_geo = private_objs.a_geo;
                
                
                let s_guid = o_in.s_guid;
                let urn = o_in.urn;
                let o_geojson_feature_geometry = o_in.o_geojson_feature_geometry;
                //                let style = o_in.style;
                let style_simple = o_in.style_simple;
                //                let b_is_icon = o_in.b_is_icon;
                //                let a_icon_size_xy = o_in.a_icon_size_xy;
                let f_onclick = o_in.f_onclick;
                
                if (f_get_pos(s_guid) !== undefined) this.f_remove(s_guid);

                /*
                console.log("o_geojson_feature_geometry:");
                console.log(o_geojson_feature_geometry);
                */

                let b_geom_has_content = NSGeoJson.f_geojson_geometry_has_content(o_geojson_feature_geometry);
                if(!b_geom_has_content)
                {
                    return;
                }
                
                let s_geometry_type = o_geojson_feature_geometry.type
                //console.log("s_geometry_type="+s_geometry_type);
                
                let o_geojson_feature = NSGeoJson.f_get_geojson_feature_from_geojson_geometry(o_geojson_feature_geometry);
                
                /*
                console.log("o_geojson_feature:");
                console.log(o_geojson_feature);
                */
                let o_ol_feature = new GeoJSON().readFeature(o_geojson_feature);
                o_ol_feature.custom_extra_info = {}
                o_ol_feature.custom_extra_info.style_simple = style_simple;

                o_ol_feature.custom_extra_info.f_onclick = f_onclick;

                /*                
                if(b_is_icon)
                {
                    o_ol_feature.custom_extra_info = {}
                    o_ol_feature.custom_extra_info.b_is_icon = b_is_icon;
                    o_ol_feature.custom_extra_info.a_icon_size_xy = a_icon_size_xy;
                }
 */               
                /*
                console.log("o_ol_feature:");
                console.log(o_ol_feature);
                */

                private_objs.vector_source.addFeature(o_ol_feature);
                
                
                let o_geo_wrapper_in = {
                    guid: s_guid,
                    urn: urn,
                    geometry_type: s_geometry_type,
                    vector: o_ol_feature,
                }
                let o_geo_wrapper = new NSObjDetailsGeoPrivate.objs.GeoVectorWrapper(o_geo_wrapper_in);
                a_geo.push(o_geo_wrapper);
            };
            
            this.f_remove = function (s_guid)
            {
                //let private_objs = this.private_objs;
                let a_geo = private_objs.a_geo;
                
                let i_pos = f_get_pos(s_guid);
                if(i_pos != null && i_pos >-1)
                {
                    let o_geo_wrapper = private_objs.a_geo[i_pos];
                
                    let o_ol_feature = o_geo_wrapper.vector;
                    
                    private_objs.vector_source.removeFeature(o_ol_feature);
                    
                    a_geo.splice(i_pos,1);	//removing element of the array (original array is changed by splice method)
                }
                
                
            };

            this.f_remove_all = function ()
            {
                //var private_objs = this.private_objs;
                //var a_geo = private_objs.a_geo;
                
                private_objs.vector_source.clear();
                private_objs.a_geo = [];
                
            };

            this.f_destroy = function()
            {
                let o_vl = private_objs.vector_layer;

                this.f_remove_all();


                unByKey(private_objs.map_click_listner_key);

                private_objs.map.removeLayer(o_vl);
            }
            
            this.f_get = function(s_guid)
            {
                //var private_objs = this.private_objs;
                var a_geo = private_objs.a_geo;
                
                var i_pos = f_get_pos(s_guid);
                var o_res = (i_pos != null)? a_geo[i_pos]: null;
                
                return o_res;
                
            }
            
            this.f_getGeoJsonAndStyles = function()
            {
                const geojsonFormat = new GeoJSON();
                const vector_source = private_objs.vector_source;
                const features = vector_source.getFeatures();

                return features.map(feature => {
                    const geojson = geojsonFormat.writeFeatureObject(feature);
                    const style_simple = feature.custom_extra_info?.style_simple || null;

                    return {
                        geojson,
                        style_simple
                    };
                });
            }
        
        },


        
		/**
		o_in: {
			guid,
			urn,
			geometry_type,
			vector,
		}
		*/
		GeoVectorWrapper: function(o_in)
		{
			this.guid = o_in.guid;
			this.urn = o_in.urn;
			this.geometry_type = o_in.geometry_type;	//type "Point" || "Polygon" || ...
			this.vector = o_in.vector;
		},


        /**
         * 
         * @param {*} o_in {s_guid, urn, o_geojson_feature_geometry, style_simple, f_onclick}
         * @property {string} s_guid
         * @property {string} urn
         * @property {} o_geojson_feature_geometry a geojson feature geometry
         * @property {GeoHighlightStyleSimpleIn} style_simple
         * @property {function} f_onclick
         */
        AddFromGeojsonGeometryIn: function(o_in)
        {
            let o_input = (o_in)? o_in : {};

            this.s_guid = o_input.s_guid;
            this.urn = o_input.urn;
            this.o_geojson_feature_geometry = o_input.o_geojson_feature_geometry;
            this.style_simple = o_input.style_simple;
            this.f_onclick = o_input.f_onclick;
        },

        /**
         * @property {boolean} b_add_displacement_to_highlight_an_icon  means this geometry will be centered arround an icon with the dimensions in a_icon_size_xy
         * @property {[integer]} a_icon_size_xy                         ex: [30,40]
         * 
         * @property {string} color                                     hex, ex: "#ffffff"
         * @property {number} opacity                                  >= 0.0 && <=1.0
         * @property {integer} width
         * @property {string} fill_color                                hex, ex: "#ffffff"
         * @property {number} fill_opacity                              >= 0.0 && <=1.0
         * 
         */
        GeoHighlightStyleSimpleIn: function(o_in)
        {
            let o_input = (o_in)? o_in : {};
            
            this.b_add_displacement_to_highlight_an_icon = o_input.b_add_displacement_to_highlight_an_icon;
            this.a_icon_size_xy = o_input.a_icon_size_xy;

            this.color = o_input.color;
            this.opacity = o_input.opacity;
            this.width = o_input.width;
            this.fill_color = o_input.fill_color;
            this.fill_opacity = o_input.fill_opacity;
        }

    }

}

/*
Test Example:

o_geo_highlight_collection = new  NSObjDetailsGeo_.objs.GeoHighlight()

o_geo_highlight_collection.f_add_from_geojson_geometry(
{
	s_guid: "guid_1234",
	urn: "urn_abc",
	o_geojson_feature_geometry:{
        "type": "Point",
        "coordinates": [
          -1048644.0683,
          4678252.6849
        ]
      }
})

o_geo_highlight_collection.f_add_from_geojson_geometry(
{
	s_guid: "guid_1235",
	urn: "urn_abc",
	o_geojson_feature_geometry:{
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -1048673.612,
                4678180.4916
              ],
              [
                -1048685.5478,
                4678172.2934
              ],
              [
                -1048693.4816,
                4678167.6835
              ],
              [
                -1048702.978,
                4678183.3972
              ],
              [
                -1048701.6015,
                4678184.059
              ],
              [
                -1048705.1032,
                4678190.4347
              ],
              [
                -1048687.9774,
                4678201.1691
              ],
              [
                -1048687.0134,
                4678200.8615
              ],
              [
                -1048673.612,
                4678180.4916
              ]
            ]
          ]
        ]
      }

})

o_geo_highlight_collection.f_destroy();

*/